import api from "../../api";
import {AxiosResponse} from "axios";
import {UserModuleServiceInterface} from "../../types";
import {
    MyAccountPasswordEditRequest,
    UserActiveRoleEditRequest,
    UserAddRequest,
    UserChangePasswordRequest,
    UserEditRequest,
    UserListRequest,
    UserPrepareEditFormRequest, UserResetOtpRequest,
    UserViewRequest
} from "../../types/modules/user/request";
import {BaseAddResponse, BaseEditResponse, EmptyResponse} from "../../types/response";
import {
    MyAccountViewResponse,
    UserListResponse,
    UserPrepareAddFormResponse,
    UserPrepareEditFormResponse,
    UserViewResponse
} from "../../types/modules/user/response";

export class UserService implements UserModuleServiceInterface {

    public list(request: UserListRequest): Promise<AxiosResponse<UserListResponse>> {
        return api.get('/user_administration/user/', { params: request });
    }
    public edit(request: UserEditRequest): Promise<AxiosResponse<BaseEditResponse>> {
        return api.put(`/user_administration/user/${request.id}/edit`, request);
    }
    public view(request: UserViewRequest): Promise<AxiosResponse<UserViewResponse>> {
        return api.get(`/user_administration/user/${request.id}/view`);
    }
    public add(request: UserAddRequest): Promise<AxiosResponse<BaseAddResponse>> {
        return api.post(`/user_administration/user/add`, request);
    }

    public changePassword(request: UserChangePasswordRequest): Promise<AxiosResponse<EmptyResponse>> {
        return api.put(`/user_administration/user/${request.id}/change_password`, request);
    }

    public prepareEditForm(request: UserPrepareEditFormRequest): Promise<AxiosResponse<UserPrepareEditFormResponse>> {
        return api.get(`/user_administration/user/${request.id}/prepare_edit`);
    }

    public prepareAddForm(): Promise<AxiosResponse<UserPrepareAddFormResponse>> {
        return api.get(`/user_administration/user/prepare_add`);
    }

    public myAccount(): Promise<AxiosResponse<MyAccountViewResponse>> {
        return api.get(`/user_administration/my_account/view`);
    }

    public myAccountEdit(request: UserEditRequest): Promise<AxiosResponse<UserViewResponse>> {
        return api.put(`/user_administration/my_account/edit`, request);
    }

    public setActiveRole(request: UserActiveRoleEditRequest): Promise<AxiosResponse<EmptyResponse>> {
        return api.put(`/user_administration/my_account/change_role`, request);
    }

    public myAccountPasswordEdit(request: MyAccountPasswordEditRequest): Promise<AxiosResponse<EmptyResponse>> {
        return api.put(`/user_administration/my_account/change_password`, request);
    }

    public resetOtp(request: UserResetOtpRequest): Promise<AxiosResponse<EmptyResponse>> {
        return api.put(`/user_administration/user/${request.id}/reset_otp`);
    }
}